import { Expose as BaseExpose, plainToInstance as basePlainToInstance, instanceToPlain as baseInstanceToPlain, } from 'class-transformer';
export const GROUP_DEFAULT = '_default';
const defaultClassTransformOptions = {
    excludeExtraneousValues: true,
    enableImplicitConversion: true,
    exposeDefaultValues: true,
    enableCircularCheck: true,
    groups: [GROUP_DEFAULT],
};
export const defaultInstanceToPlainOptions = {
    ...defaultClassTransformOptions,
    excludeExtraneousValues: true,
};
export const defaultPlainToInstanceOptions = {
    ...defaultClassTransformOptions,
    excludeExtraneousValues: false,
};
/**
 * To use on class properties instead of base expose,
 * to allow Expose a property to only a single endpoint:
 *
 * @Expose() => same as base expose
 * @Expose(['custom']) => expose only if 'custom' group is used (base expose will also expose if not group is used)
 * @Expose([GROUP_DEFAULT, 'custom']) => same as base @Expose(['custom']), expose when no group is provided, or if custom is provided
 *
 * This implies GROUP_DEFAULT group is provided in base configuration.
 */
export const Expose = (options) => BaseExpose({
    ...defaultInstanceToPlainOptions,
    ...options,
});
export const plainToInstance = (cls, plain, options) => basePlainToInstance(cls, plain, {
    ...defaultPlainToInstanceOptions,
    ...options,
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const instanceToPlain = (object, options) => baseInstanceToPlain(object, {
    ...defaultInstanceToPlainOptions,
    ...options,
});
